import Vue from "vue";
import Router from "vue-router";
import { routers } from "./defines";

Vue.use(Router);

const RouterConfig = {
  mode: "hash",/*  */
  base: process.env.BASE_URL,
  routes: routers,
  //   scrollBehavior(to, from, savedPosition) {
  //     if (savedPosition) {
  //       return savedPosition;
  //     } else {
  //       return { x: to, y: from};
  //     }
  //   }
 
};

const router = new Router(RouterConfig);

export default router;
